<nz-card
  class="rounded-lg mt-3 p-4 mb-3 border-none shadow-sm hover:shadow-md transition-shadow"
  nzHoverable
>
  <nz-skeleton
    *ngIf="loading"
    [nzLoading]="loading"
    [nzActive]="true"
  ></nz-skeleton>

  <div *ngIf="!loading" class="flex flex-col mb-4">
    <div class="py-1 text-xl font-semibold">Webhook Payment</div>
    <span class="text-gray-600">
      A webhook is an automatic link between apps, sending data instantly when a
      specific event occurs. It enables real-time updates without manual checks.
    </span>
  </div>

  <div
    class="flex flex-col md:flex-row justify-end items-start md:items-center gap-2 mt-2 mb-6"
  >
    <div class="flex items-center w-full md:w-auto overflow-hidden">
      <nz-input-group
        [nzPrefix]="prefixTemplateSearch"
        class="w-full md:w-[350px]"
      >
        <input
          type="text"
          nz-input
          placeholder="Payment ID"
          [(ngModel)]="search"
          (ngModelChange)="onChangeSearch($event)"
          class="rounded-lg h-9 border-gray-300 focus:border-primary focus:ring-1 focus:ring-primary"
        />
      </nz-input-group>
      <ng-template #prefixTemplateSearch>
        <i class="icon-search-normal-1 text-gray-400"></i>
      </ng-template>
    </div>

    <div class="flex items-center gap-2">
      <div
        ngbDropdown
        class="relative inline-block"
        #dropdownFilter="ngbDropdown"
      >
        <button
          type="button"
          class="flex items-center justify-center bg-primary text-white h-11 w-11 rounded-lg hover:opacity-90 transition-opacity"
          id="dropdownFilterOrder"
          ngbDropdownToggle
        >
          <i class="icon-filter-search text-white text-xl"></i>
        </button>

        <div
          ngbDropdownMenu
          aria-labelledby="dropdownFilterOrder"
          class="min-w-[200px] shadow-lg border border-gray-100 rounded-lg py-2 mt-1"
        >
          <button
            ngbDropdownItem
            disabled
            class="px-4 py-2 text-black font-bold border-b border-gray-100"
          >
            Filter
          </button>

          <div ngbDropdown placement="left-top" class="w-full">
            <button
              type="button"
              class="w-full px-4 py-2 text-left hover:bg-gray-50 flex justify-between items-center group"
              id="dropdownStatus"
              ngbDropdownToggle
            >
              <span>Status</span>
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="dropdownStatus"
              class="min-w-[150px] shadow-lg border border-gray-100 rounded-lg py-2 ml-1"
            >
              <div class="px-4 py-1">
                <div
                  class="flex items-center gap-2 mb-2 last:mb-0 cursor-pointer group"
                  *ngFor="let list of status; let i = index"
                >
                  <input
                    class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary cursor-pointer form-check-input"
                    type="checkbox"
                    [value]="list.value"
                    [id]="list.id"
                    [checked]="list.checked"
                    (change)="getStatus($event, list)"
                  />
                  <label
                    class="text-gray-700 cursor-pointer group-hover:text-primary transition-colors"
                    [for]="list.id"
                  >
                    {{ list.label }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="w-full px-4 py-2 text-left hover:bg-gray-50 flex justify-between items-center group ngx-daterangepicker-action"
            id="dropdownPeriod"
            (click)="openDatepicker()"
          >
            Period
          </button>

          <div id="dropdownPeriod">
            <input
              type="text"
              class="btn p-0 date-pick w-100 lg:w-[700px]"
              ngxDaterangepickerMd
              [(ngModel)]="selected"
              [ngModelOptions]="{ standalone: true }"
              [showCustomRangeLabel]="false"
              [keepCalendarOpeningWithRange]="true"
              [alwaysShowCalendars]="true"
              [ranges]="ranges"
              [linkedCalendars]="true"
              [isInvalidDate]="isInvalidDate"
              [showCancel]="true"
              [locale]="setlocale"
              (change)="onChangeDate($event)"
              opens="center"
              drops="down"
              container="body"
              style="border: none; font-size: 14px; display: none"
              #datePickerInput
            />
          </div>

          <div class="border-t border-gray-100 mt-2">
            <button
              type="button"
              class="w-full px-4 py-2 text-left text-red-500 hover:bg-red-50 transition-colors font-medium"
              (click)="resetFilter()"
            >
              Reset Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col w-full overflow-hidden rounded-lg shadow-sm mt-4">
    <nz-table
      #basicTable
      [nzData]="dataWebHook || []"
      [nzFrontPagination]="false"
      [nzLoading]="loading"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '1000px' }"
      class="w-full text-left"
    >
      <thead>
        <tr class="bg-gray-100">
          <th
            class="px-6 py-4 font-semibold tracking-wider"
          >
            Status
          </th>
          <th class="px-6 py-4 font-semibold tracking-wider">
            Date Created
          </th>
          <th class="px-6 py-4 font-semibold tracking-wider">
            Payment ID
          </th>
          <th class="px-6 py-4 font-semibold tracking-wider">
            Transaction Type
          </th>
          <th class="px-6 py-4 font-semibold tracking-wider"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 bg-white">
        <tr
          *ngFor="let item of basicTable.data"
          class="hover:bg-gray-50 transition-colors group"
        >
          <td class="px-6 py-4 whitespace-nowrap">
            <span
              class="inline-flex items-center justify-center px-4 py-1 rounded-full text-xs font-medium border"
              [ngClass]="{
                'bg-green-50 border-green-200 text-green-700':
                  item.status === 'success' || item.status === 200,
                'bg-red-50 border-red-200 text-red-700':
                  item.status === 'failed' ||
                  item.status === 400 ||
                  item.status === 404,
                'bg-yellow-50 border-yellow-200 text-yellow-700':
                  item.status === 'pending',
                'bg-gray-50 border-gray-200 text-gray-700': ![
                  'success',
                  'failed',
                  'pending',
                  200,
                  400,
                  404
                ].includes(item.status)
              }"
            >
              {{ getStatusValue(item.status) }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-gray-600 text-sm">
            {{ item.created_at | date : "dd MMM yyyy, HH.mm a" }}
          </td>
          <td
            class="px-6 py-4 whitespace-nowrap text-gray-900 font-medium text-sm"
          >
            {{ item.payment_id }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-gray-600 text-sm">
            {{ getPaymentValue(item.payment_type) }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm">
            <div
              class="flex justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <button
                class="bg-primary hover:bg-opacity-90 text-white px-4 py-2 rounded-lg transition-colors text-xs font-medium"
                (click)="onResend(item)"
              >
                Resend
              </button>
              <button
                class="border border-gray-200 hover:border-primary hover:text-primary px-4 py-2 rounded-lg transition-all text-xs font-medium"
                (click)="onDetail(item.payment_id)"
              >
                Detail
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <app-pagination
    [currentPage]="currentPage"
    [totalItems]="totalList"
    [perPage]="filterWebHook.limit"
    [disablePrev]="isDisPrev"
    [disableNext]="isDisNext"
    [perPageOptions]="perPageOptions"
    (pageChange)="onPageChange($event)"
    (perPageChange)="onPerPageChange($event)"
  >
  </app-pagination>
</nz-card>
